import React, { Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import { isDisplayable } from "util/misc";
import { fieldExistsOnPlayType } from "games/utils";

const PlayTimeInput = ({
  inputName,
  label,
  handleInputChange,
  play,
  classes,
  helperText = null
}) => {
  const formatValue = (val) => {
    return isDisplayable(val) ? val : "";
  };

  return (
    <Fragment>
      {fieldExistsOnPlayType(play.playType, inputName) && (
        <TextField
          id={inputName}
          label={label}
          type="time"
          onChange={(event) => handleInputChange(event, inputName)}
          value={formatValue(play[inputName])}
          variant="filled"
          className={classes.input}
          helperText={helperText}
        />
      )}
    </Fragment>
  );
};

export default PlayTimeInput;
